// frontend/src/pages/admin/TopicDuplicatesModal.js
import { useState, useEffect } from 'react';
import { useAuthFetch } from '../../hooks/useAuthFetch';

export default function TopicDuplicatesModal({ onClose, onMerge }) {
  const { authFetch } = useAuthFetch();
  const [pairs, setPairs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    authFetch(`${process.env.REACT_APP_API_URL}/api/admin/topics/duplicates`)
      .then(res => res.json())
      .then(data => { setPairs(data); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleBackdrop = (e) => { if (e.target === e.currentTarget) onClose(); };

  return (
    <div
      onClick={handleBackdrop}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <div style={{ background: 'var(--color-surface)', borderRadius: '12px', border: '1px solid var(--color-border)', padding: '1.5rem', width: '620px', maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
          <div style={{ fontWeight: 700, fontSize: '1rem' }}>Find Duplicates</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.2rem', color: 'var(--color-text-muted)' }}>✕</button>
        </div>

        {loading && <p style={{ color: 'var(--color-text-subtle)', fontSize: '0.85rem' }}>Scanning for similar topics…</p>}
        {error && <p style={{ color: 'var(--color-danger, red)', fontSize: '0.85rem' }}>{error}</p>}

        {!loading && !error && pairs.length === 0 && (
          <p style={{ color: 'var(--color-text-subtle)', fontSize: '0.85rem' }}>No similar topic pairs found (threshold: 85% similarity).</p>
        )}

        {pairs.map((pair, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', borderRadius: '8px', border: '1px solid var(--color-border)', marginBottom: '0.6rem', gap: '1rem' }}>
            <div style={{ flex: 1, fontSize: '0.85rem' }}>
              <div style={{ fontWeight: 600 }}>{pair.topicA.name}</div>
              <div style={{ fontSize: '0.72rem', color: 'var(--color-text-subtle)' }}>{pair.topicA.domain_name} › {pair.topicA.group_name}</div>
            </div>
            <div style={{ textAlign: 'center', fontSize: '0.78rem', fontWeight: 700, color: 'var(--color-accent)', whiteSpace: 'nowrap' }}>
              {Math.round(pair.similarity * 100)}% similar
            </div>
            <div style={{ flex: 1, fontSize: '0.85rem', textAlign: 'right' }}>
              <div style={{ fontWeight: 600 }}>{pair.topicB.name}</div>
              <div style={{ fontSize: '0.72rem', color: 'var(--color-text-subtle)' }}>{pair.topicB.domain_name} › {pair.topicB.group_name}</div>
            </div>
            <button
              onClick={() => { onMerge(pair.topicA, pair.topicB); onClose(); }}
              style={{ padding: '0.25rem 0.75rem', borderRadius: '6px', fontSize: '0.78rem', fontWeight: 500, border: '1px solid var(--color-border-strong)', background: 'var(--color-surface)', color: 'var(--color-text-muted)', cursor: 'pointer', whiteSpace: 'nowrap' }}
            >
              Merge
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
